// import React, { useState } from "react";
// import { 
//   AppBar, 
//   Toolbar, 
//   Typography, 
//   Button, 
//   IconButton, 
//   Drawer, 
//   List, 
//   ListItem, 
//   ListItemText, 
//   Box, 
//   Container, 
//   useMediaQuery, 
//   useTheme,
//   Avatar,
//   Divider
// } from "@mui/material";
// import MenuIcon from '@mui/icons-material/Menu';
// import CloseIcon from '@mui/icons-material/Close';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
// import RockkPayLogo from '../Assets/Rockkpay/RockkpayLogo.png';
// import { useNavigate } from "react-router-dom";


// const HeaderTwo = () => {
//     const navigate = useNavigate();
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));

//   const handleDrawerToggle = () => {
//     setMobileOpen(!mobileOpen);
//   };

//   const handleLoginClick = () => {
//     navigate("/signin");
//   };

//   const navItems = ['Home', 'Features', 'How It Works', 'FAQ', 'Contact'];

//   const drawer = (
//     <Box sx={{ 
//       width: 280, 
//       height: '100%', 
//       background: 'linear-gradient(135deg, #111827, #1f2937)', 
//       color: 'white',
//       pt: 2
//     }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pb: 2 }}>
//         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//           <Avatar 
//             src={RockkPayLogo} 
//             alt="RockkPay Logo"
//             sx={{ 
//               width: 40, 
//               height: 40,
//               border: '2px solid #60a5fa',
//               boxShadow: '0 0 10px rgba(96, 165, 250, 0.6)'
//             }}
//           />
//           <Typography variant="h6" sx={{ ml: 2, fontWeight: 600 }}>RockkPay</Typography>
//         </Box>
//         <IconButton edge="end" color="inherit" onClick={handleDrawerToggle} aria-label="close">
//           <CloseIcon />
//         </IconButton>
//       </Box>
//       <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', my: 1 }} />
//       <List sx={{ px: 1 }}>
//         {navItems.map((item) => (
//           <ListItem 
//             button 
//             key={item} 
//             onClick={handleDrawerToggle}
//             sx={{
//               borderRadius: 2,
//               my: 0.5,
//               '&:hover': {
//                 backgroundColor: 'rgba(255, 255, 255, 0.1)'
//               }
//             }}
//           >
//             <ListItemText 
//               primary={item} 
//               primaryTypographyProps={{ fontWeight: 500 }}
//             />
//           </ListItem>
//         ))}
//       </List>
//       <Box sx={{ px: 3, mt: 4 }}>
//         <Button 
//           fullWidth 
//           variant="contained" 
//           endIcon={<ArrowForwardIcon />}
//           onClick={handleLoginClick}
//           sx={{
//             backgroundColor: '#60a5fa',
//             borderRadius: 2,
//             py: 1.2,
//             textTransform: 'none',
//             fontWeight: 600,
//             boxShadow: '0 4px 14px rgba(96, 165, 250, 0.4)',
//             '&:hover': {
//               backgroundColor: '#3b82f6'
//             }
//           }}
//         >
//           Get Started
//         </Button>
//       </Box>
//     </Box>
//   );

//   return (
//     <AppBar 
//       position="sticky" 
//       elevation={0}
//       sx={{
//         background: 'linear-gradient(to right, #0f172a, #1e293b)',
//         borderBottom: '1px solid rgba(255, 255, 255, 0.08)'
//       }}
//     >
//       <Container maxWidth="xl">
//         <Toolbar sx={{ py: { xs: 1.5, md: 2 }, justifyContent: 'space-between' }}>
//           {/* Logo and Brand */}
//           <Box sx={{ display: 'flex', alignItems: 'center' }}>
//             <Avatar 
//               src={RockkPayLogo} 
//               alt="RockkPay Logo" 
//               sx={{ 
//                 width: { xs: 40, md: 48 }, 
//                 height: { xs: 40, md: 48 },
//                 border: '2px solid #60a5fa',
//                 boxShadow: '0 0 15px rgba(96, 165, 250, 0.5)',
//                 transition: 'all 0.3s ease',
//                 '&:hover': {
//                   transform: 'scale(1.05)',
//                   boxShadow: '0 0 20px rgba(96, 165, 250, 0.7)'
//                 }
//               }} 
//             />
//             <Box sx={{ ml: 2 }}>
//               <Typography 
//                 variant="h5" 
//                 component="div"
//                 sx={{ 
//                   fontWeight: 700,
//                   color: 'white',
//                   letterSpacing: '0.5px',
//                   display: { xs: 'none', sm: 'block' }
//                 }}
//               >
//                 RockkPay
//               </Typography>
//               <Typography 
//                 variant="body2" 
//                 sx={{ 
//                   color: '#94a3b8',
//                   display: { xs: 'none', sm: 'block' }
//                 }}
//               >
//                 Smart Payment Solutions
//               </Typography>
//             </Box>
//           </Box>

//           {/* Desktop Navigation */}
//           {!isMobile ? (
//             <Box sx={{ display: 'flex', alignItems: 'center' }}>
//               {navItems.map((item) => (
//                 <Button 
//                   key={item} 
//                   color="inherit"
//                   sx={{ 
//                     mx: 0.7,
//                     px: 2,
//                     py: 0.8,
//                     color: '#e2e8f0',
//                     fontWeight: 500,
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&:hover': {
//                       backgroundColor: 'transparent',
//                       '&::after': {
//                         width: '100%'
//                       }
//                     },
//                     '&::after': {
//                       content: '""',
//                       position: 'absolute',
//                       bottom: 0,
//                       left: 0,
//                       width: 0,
//                       height: '2px',
//                       backgroundColor: '#60a5fa',
//                       transition: 'width 0.3s ease'
//                     }
//                   }}
//                 >
//                   {item}
//                 </Button>
//               ))}
//               <Button 
//                 variant="contained" 
//                 endIcon={<ArrowForwardIcon />}
//                 onClick={handleLoginClick}
//                 sx={{ 
//                   ml: 3,
//                   px: 3,
//                   py: 1,
//                   backgroundColor: '#60a5fa',
//                   borderRadius: '8px',
//                   textTransform: 'none',
//                   fontWeight: 600,
//                   boxShadow: '0 4px 14px rgba(96, 165, 250, 0.4)',
//                   transition: 'all 0.2s ease',
//                   '&:hover': {
//                     backgroundColor: '#3b82f6',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 6px 20px rgba(96, 165, 250, 0.5)',
//                   }
//                 }}
//               >
//                 Get Started
//               </Button>
//             </Box>
//           ) : (
//             <IconButton
//               color="inherit"
//               aria-label="open drawer"
//               edge="end"
//               onClick={handleDrawerToggle}
//               sx={{ 
//                 color: '#e2e8f0',
//                 backgroundColor: 'rgba(255, 255, 255, 0.05)',
//                 '&:hover': {
//                   backgroundColor: 'rgba(255, 255, 255, 0.1)'
//                 }
//               }}
//             >
//               <MenuIcon />
//             </IconButton>
//           )}
//         </Toolbar>
//       </Container>

//       {/* Mobile Navigation Drawer */}
//       <Drawer
//         anchor="right"
//         open={mobileOpen}
//         onClose={handleDrawerToggle}
//         PaperProps={{
//           sx: {
//             borderRadius: '12px 0 0 12px',
//             boxShadow: '-5px 0 25px rgba(0,0,0,0.5)'
//           }
//         }}
//       >
//         {drawer}
//       </Drawer>
//     </AppBar>
//   );
// };

// export default HeaderTwo;

import React, { useState } from "react";
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  IconButton, 
  Drawer, 
  List, 
  ListItem, 
  ListItemText, 
  Box, 
  Container, 
  useMediaQuery, 
  useTheme,
  Avatar,
  Divider
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RockkPayLogo from '../Assets/Rockkpay/RockkpayLogo.png';
import { useNavigate } from "react-router-dom";


const HeaderTwo = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLoginClick = () => {
    navigate("/signin");
  };

  // Updated navigation items with section IDs
  const menuItems = [
    { label: 'Home', id: 'Home-Section-One' },
    { label: 'About', id: 'Home-Section-Two' },
    { label: 'Services', id: 'Home-Section-Three' },
    { label: 'Features', id: 'Home-Section-Four' },
    { label: 'Contact', id: 'Home-Section-Five' },
  ];

  // Function to scroll to the section when menu item is clicked
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    // Close the drawer if it's open
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  const drawer = (
    <Box sx={{ 
      width: 280, 
      height: '100%', 
      background: 'linear-gradient(135deg, #111827, #1f2937)', 
      color: 'white',
      pt: 2
    }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 3, pb: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Avatar 
            src={RockkPayLogo} 
            alt="RockkPay Logo"
            sx={{ 
              width: 40, 
              height: 40,
              border: '2px solid #60a5fa',
              boxShadow: '0 0 10px rgba(96, 165, 250, 0.6)'
            }}
          />
          <Typography variant="h6" sx={{ ml: 2, fontWeight: 600 }}>RockkPay</Typography>
        </Box>
        <IconButton edge="end" color="inherit" onClick={handleDrawerToggle} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider sx={{ backgroundColor: 'rgba(255, 255, 255, 0.1)', my: 1 }} />
      <List sx={{ px: 1 }}>
        {menuItems.map((item) => (
          <ListItem 
            button 
            key={item.id} 
            onClick={() => scrollToSection(item.id)}
            sx={{
              borderRadius: 2,
              my: 0.5,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            <ListItemText 
              primary={item.label} 
              primaryTypographyProps={{ fontWeight: 500 }}
            />
          </ListItem>
        ))}
      </List>
      <Box sx={{ px: 3, mt: 4 }}>
        <Button 
          fullWidth 
          variant="contained" 
          endIcon={<ArrowForwardIcon />}
          onClick={handleLoginClick}
          sx={{
            background: 'linear-gradient(45deg,rgb(246, 162, 59),rgb(250, 193, 96))',
            borderRadius: 2,
            py: 1.2,
            textTransform: 'none',
            fontWeight: 600,
            transition: 'all 0.3s ease',
  boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
  '&:hover': {
    background: 'linear-gradient(45deg,rgb(235, 159, 37),rgb(246, 143, 59))',
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(246, 209, 59, 0.5)',
  },
          }}
        >
          Get Started
        </Button>
      </Box>
    </Box>
  );

  return (
    <AppBar 
      position="sticky" 
      elevation={0}
      sx={{
        background: 'linear-gradient(to right, #0f172a, #1e293b)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)'
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ py: { xs: 1.5, md: 2 }, justifyContent: 'space-between' }}>
          {/* Logo and Brand */}
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Avatar 
              src={RockkPayLogo} 
              alt="RockkPay Logo" 
              sx={{ 
                width: { xs: 40, md: 48 }, 
                height: { xs: 40, md: 48 },
                border: '2px solid #60a5fa',
                boxShadow: '0 0 15px rgba(96, 165, 250, 0.5)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.05)',
                  boxShadow: '0 0 20px rgba(96, 165, 250, 0.7)'
                }
              }} 
            />
            <Box sx={{ ml: 2 }}>
              <Typography 
                variant="h5" 
                component="div"
                sx={{ 
                  fontWeight: 700,
                  color: 'white',
                  letterSpacing: '0.5px',
                  display: { xs: 'none', sm: 'block' }
                }}
              >
                RockkPay
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#94a3b8',
                  display: { xs: 'none', sm: 'block' }
                }}
              >
                Smart Payment Solutions
              </Typography>
            </Box>
          </Box>

          {/* Desktop Navigation */}
          {!isMobile ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {menuItems.map((item) => (
                <Button 
                  key={item.id} 
                  color="inherit"
                  onClick={() => scrollToSection(item.id)}
                  sx={{ 
                    mx: 0.7,
                    px: 2,
                    py: 0.8,
                    color: '#e2e8f0',
                    fontWeight: 500,
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      '&::after': {
                        width: '100%'
                      }
                    },
                    '&::after': {
                      content: '""',
                      position: 'absolute',
                      bottom: 0,
                      left: 0,
                      width: 0,
                      height: '2px',
                      backgroundColor: '#60a5fa',
                      transition: 'width 0.3s ease'
                    }
                  }}
                >
                  {item.label}
                </Button>
              ))}
              <Button 
                variant="contained" 
                // endIcon={<ArrowForwardIcon />}
                onClick={handleLoginClick}
                sx={{ 
                  ml: 3,
                  px: 3,
                  py: 1,
                  background: 'linear-gradient(45deg,rgb(246, 162, 59),rgb(250, 193, 96))',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  boxShadow: '0 4px 14px rgba(96, 165, 250, 0.4)',
                  transition: 'all 0.3s ease',
  boxShadow: '0 4px 14px rgba(59, 130, 246, 0.4)',
  '&:hover': {
    background: 'linear-gradient(45deg,rgb(235, 159, 37),rgb(246, 143, 59))',
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(246, 209, 59, 0.5)',
  },
                }}
              >
                Login
              </Button>
            </Box>
          ) : (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="end"
              onClick={handleDrawerToggle}
              sx={{ 
                color: '#e2e8f0',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                '&:hover': {
                  backgroundColor: 'rgba(255, 255, 255, 0.1)'
                }
              }}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </Container>

      {/* Mobile Navigation Drawer */}
      <Drawer
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            borderRadius: '12px 0 0 12px',
            boxShadow: '-5px 0 25px rgba(0,0,0,0.5)'
          }
        }}
      >
        {drawer}
      </Drawer>
    </AppBar>
  );
};

export default HeaderTwo;